import { c as _c } from "react/compiler-runtime";
import useCapacitor from "@/hooks/useCapacitor";
import styles from "./Header.module.scss";
export default function HeaderPlaceholder() {
  const $ = _c(2);
  const capacitor = useCapacitor();
  const t0 = capacitor.isCapacitor ? styles.headerPlaceholderCapacitor : styles.headerPlaceholder;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className={t0} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}